module.exports = __webpack_public_path__ + "img/icon-homepage-country-data-dark-16.f048dee.svg";